interface ExamPerformanceCardProps {
  correct: number;
  score: number;
  title: string;
  total: number;
}

export function ExamPerformanceCard({
  correct,
  score,
  title,
  total,
}: ExamPerformanceCardProps) {
  const onTarget = score >= 70;

  return (
    <article className="flex min-h-[114px] flex-col justify-between rounded-2xl border border-[#dddfe4] p-4">
      <div className="flex items-start justify-between gap-3">
        <h3 className="max-w-[145px] text-sm font-semibold leading-[21px] text-[#0a0c11]">{title}</h3>
        <span className={`rounded-full px-3 py-1 text-base font-semibold ${onTarget ? "bg-[var(--dp-brand-soft)] text-[var(--dp-brand-button)]" : "bg-[#fff5df] text-[#b57806]"}`}>{score}%</span>
      </div>
      <div className="flex items-center gap-4">
        <div className="h-3 flex-1 overflow-hidden rounded-full bg-[#ebecf0]">
          <div className={`h-full rounded-full ${onTarget ? "bg-[var(--dp-brand-button)]" : "bg-[#b98514]"}`} style={{ width: `${score}%` }} />
        </div>
        <span className="text-base text-[#5b616d]">{correct}/{total}</span>
      </div>
    </article>
  );
}
